const loading = {
  state: {
    isShow:false
  },
  mutations: {
    SET_STATE: (state,data)=>{
      state.isShow = data;
    }
  },

}
export default loading;



// WEBPACK FOOTER //
// ./src/store/modules/loading.js